var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { dasherize } from '@ember/string';
import { pluralize } from 'ember-inflector';
import RESTAdapter from '@ember-data/adapter/rest';
import { baseRpcUrl } from '@square/dashboard-utilities/utils/url';
import { getCsrfToken } from '@square/dashboard-utilities/utils/csrf';
import { inject as service } from '@ember/service';
let MenuConfiguration = (_class = class MenuConfiguration extends RESTAdapter {
  constructor(args) {
    super(args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _defineProperty(this, "useFetch", void 0);
    _defineProperty(this, "namespace", 'v2');
    _defineProperty(this, "host", baseRpcUrl('', true));
    _defineProperty(this, "headers", {
      'X-CSRF-Token': getCsrfToken()
    });
    this.useFetch = false;
  }
  ajaxOptions(url, type, options) {
    return super.ajaxOptions(url, type, {
      xhrFields: {
        withCredentials: true
      },
      ...options
    });
  }
  pathForType(type) {
    return pluralize(dasherize(type));
  }
  initialize(record) {
    const url = `${this.buildURL('menu-sync/menu-configuration', record.id)}/initialize`;
    return this.ajax(url, 'POST');
  }
  async batchCreate(records) {
    const url = `${this.buildURL('menu-sync/menu-configuration')}/batch`;
    const response = await this.ajax(url, 'POST', {
      data: {
        menu_configurations: records.map(r => r.serialize())
      }
    });
    const menuConfigurationIds = [];
    for (const menuConfiguration of response.menu_configurations) {
      const modelClass = this.store.modelFor('menu-sync/menu-configuration');
      const serializer = this.store.serializerFor('menu-sync/menu-configuration');
      const normalized = serializer.normalize(modelClass, menuConfiguration);
      this.store.push(normalized);
      menuConfigurationIds.push(menuConfiguration.id);
    }
    return menuConfigurationIds;
  }
  async bulkStateChange(menuConfigurationIds, state, reason, pauseUntilDate) {
    const url = `${this.buildURL('menu-sync/menu-configuration')}/bulk-state-change`;
    const response = await this.ajax(url, 'POST', {
      data: {
        menu_configuration_ids: menuConfigurationIds,
        state,
        reason,
        end_at: pauseUntilDate?.toISOString() ?? null
      }
    });
    return response;
  }
  async updateAndSync(record) {
    const url = `${this.buildURL('menu-sync/menu-configuration')}/${record.id}`;
    const response = await this.ajax(url, 'PUT', {
      data: {
        menu_configuration: {
          ...record.serialize()
        },
        trigger_sync: true
      }
    });
    for (const holidayHourRecord of record.holidayHours.toArray()) {
      holidayHourRecord.unloadRecord();
    }
    const modelClass = this.store.modelFor('menu-sync/menu-configuration');
    const serializer = this.store.serializerFor('menu-sync/menu-configuration');
    const normalized = serializer.normalize(modelClass, response.menu_configuration);
    this.store.push(normalized);
    return response;
  }
  async bulkUpdatePrepTime(records) {
    const url = `${this.buildURL('menu-sync/menu-configuration')}/bulk-default-prep-time`;
    const response = await this.ajax(url, 'POST', {
      data: {
        updates: records.map(r => {
          return {
            menu_configuration_id: r.id,
            default_prep_time: r.defaultPrepTime
          };
        })
      }
    });
    return response;
  }
  async bulkUpdatePickupInstructions(records) {
    const url = `${this.buildURL('menu-sync/menu-configuration')}/bulk-pickup-instructions`;
    const response = await this.ajax(url, 'POST', {
      data: {
        updates: records.map(r => {
          return {
            menu_configuration_id: r.id,
            pickup_instructions: r.pickupInstructions
          };
        })
      }
    });
    return response;
  }
  async batchUpdate(records) {
    const url = `${this.buildURL('menu-sync/menu-configuration')}/batch`;
    const response = await this.ajax(url, 'PUT', {
      data: {
        menu_configurations: records.map(r => {
          return {
            id: r.id,
            ...r.serialize()
          };
        })
      }
    });
    for (const menuConfiguration of response.menu_configurations) {
      const modelClass = this.store.modelFor('menu-sync/menu-configuration');
      const serializer = this.store.serializerFor('menu-sync/menu-configuration');
      const normalized = serializer.normalize(modelClass, menuConfiguration);
      this.store.push(normalized);
    }
    return response;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MenuConfiguration as default };